


<div class="cd-section" id="regulations" style="background-color: white; padding-top: 10px;">

    <div class="container-fluid">
        <!-- Header -->
        <div class="row ">
            <div class="header-container neg-lift ">
                <br>
                <br>
                <img width="100%" src="../../assets/img/Auditor-Header.png" alt="" />

            </div>

        </div>

        <!-- Left Section Half -->
        <div class="row">

            <!-- left side -->
            <div class="col-md-5 offset-md-1 " style=" margin-top: -25%;">

                <div class="supportcard">

                    <h2  class="trainingHeader"><b>Auditor</b></h2>
                    <h5>Learn how to easily access the evidence and information needed to support your audit workflows.
                    </h5>

                    <br>
                    <br>


                </div>
            </div>
        </div>

        <!-- 3 Cards per Row -->
        <div class="row" style="margin-top: 5%; margin-bottom: 10%;">
            <!-- Loop Over Each Filtered Video to Display -->
            <div *ngFor="let v of displayVideos" class="col-md-4">

                <div class="card">
                    <iframe style="min-height: 400px;"
					[src]="sanitizer.bypassSecurityTrustResourceUrl(v.url)"
					frameborder="0" allowfullscreen
				></iframe>
                    <div class="container" style="min-height: 150px;">
                        <hr>
                        <h4><b>{{ v.title }}</b></h4>
                        <p>{{ v.description }}</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- Center Copy-->
        <div class="row " style=" margin-top:-5%;">
            <div class="col-md-8 offset-md-2">
                <div class="text-center">
                    <h3><b>Explore other roles in RegScale.</b></h3>
                </div>
            </div>
        </div>

        <!-- Training Videos by Role -->
        <training-roles></training-roles>


    </div>
</div>
